import React from 'react';

function ExternalIcon({ width, height, className, color = "currentColor" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 13.3 13.3"
            fill="none"
            stroke={color} // Apply dynamic stroke color
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
        >
            <path
                d="M9.5,1H13V4.5m-.75-2.75L8.5,5.5M7,2H2.5A1.5,1.5,0,0,0,1,3.5v8A1.5,1.5,0,0,0,2.5,13h8A1.5,1.5,0,0,0,12,11.5V7"
                transform="translate(-0.35 -0.35)"
            />
        </svg>
    );
}

export default ExternalIcon;
